<template>
  <div class="channel-form-page">
    <Head title="Create Channel" />

    <div class="mb-6">
      <nav class="mb-2 flex items-center gap-2 text-sm text-gray-500">
        <Link href="/channel" class="font-medium text-brand-600 hover:text-brand-800">Channel</Link>
        <span>/</span>
        <span class="text-gray-700">Create</span>
      </nav>
      <p class="text-xs font-semibold uppercase tracking-[0.14em] text-brand-500">Operations</p>
      <h1 class="mt-1 text-3xl font-bold tracking-tight text-brand-900">Create Channel</h1>
      <p class="mt-1.5 text-sm text-gray-500">Add a new acquisition channel code and display name.</p>
    </div>

    <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      <div
        v-if="successMessage"
        class="mx-6 mt-5 rounded-xl border border-teal-200 bg-teal-50 px-4 py-3 text-sm text-teal-800"
      >
        {{ successMessage }}
      </div>

      <form class="p-6 md:p-8" @submit.prevent="store">
        <div class="grid grid-cols-1 gap-5 md:grid-cols-2">
          <text-input
            v-model="form.agtCd"
            :error="form.errors.agtCd"
            class="w-full"
            label="Channel Code"
            placeholder="Type ID"
          />
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="w-full"
            label="Full Name"
            placeholder="Type Full Name"
          />
        </div>

        <div class="mt-8 flex items-center justify-end gap-3 border-t border-gray-100 pt-6">
          <Link
            href="/channel"
            class="rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-50"
          >
            Cancel
          </Link>
          <loading-button
            :loading="form.processing"
            class="inline-flex items-center justify-center rounded-xl bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-700"
            type="submit"
          >
            Create Channel
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    options: Array,
    successMessage: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        agtCd: null,
        name: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/channel')
    },
  },
}
</script>
